module.exports = __webpack_public_path__ + "img/brandValue.366ca977.jpg";